/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Breakdown_Kind_Tourist_TaxInputs */

const en_price_breakdown_kind_tourist_tax = /** @type {(inputs: Price_Breakdown_Kind_Tourist_TaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tourist tax`)
};

/**
* | output |
* | --- |
* | "Tourist tax" |
*
* @param {Price_Breakdown_Kind_Tourist_TaxInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_breakdown_kind_tourist_tax = /** @type {((inputs?: Price_Breakdown_Kind_Tourist_TaxInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Breakdown_Kind_Tourist_TaxInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_breakdown_kind_tourist_tax(inputs)
});